import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 89 82"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M40.457 23.366c13.49-6.014 17.987-29.067 36.474-22.05C100.914 14.845 88.423 82 45.953 82 .985 80.497-5.51 38.901 3.483 32.387c10.992-7.963 12.491-.502 36.974-9.021"
    }, null, -1)
  ])))
}
export default { render: render }